import { render, staticRenderFns } from "./PlaceInformationForm.vue?vue&type=template&id=2fbfb505"
import script from "./PlaceInformationForm.vue?vue&type=script&lang=js"
export * from "./PlaceInformationForm.vue?vue&type=script&lang=js"
import style0 from "./PlaceInformationForm.vue?vue&type=style&index=0&id=2fbfb505&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports